import { useParams } from "react-router-dom";
import {
  Box,
  VStack,
  Heading,
  Text,
  Slider,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb,
  Divider,
} from "@chakra-ui/react";
import { useState } from "react";
import { useEffect } from "react";
import Cases from "../data/Cases";
import DicomLinkButton from "../components/Dicomlinkbutton";
import BackButton from "../components/Backbutton";

export default function CaseInformation() {
  const { caseid } = useParams();
  const chosencase = Cases.find((c) => c.caseid === caseid);

  useEffect(() => {
    if (chosencase?.casetitle) {
      document.title = chosencase.casetitle;
    } else {
      document.title = "症例情報"; // デフォルトタイトル
    }
  }, [chosencase]);

  // グレーを白に近い範囲で制限（柔らかめ）
  const grayShades = [
    "gray.50", // 明るい白に近い
    "gray.100",
    "gray.200",
    "gray.300", // これは非標準なのでgray.300に留めるか別名にして調整も可
    "gray.400", // 暗すぎないグレーで止める
  ];
  const dividerColors = [...grayShades].reverse();

  const [bgIndex, setBgIndex] = useState(0);

  return (
    <Box
      minH="100vh"
      bg={grayShades[bgIndex]}
      transition="background 0.3s ease"
      py={8}
    >
      <Box maxW="800px" mx="auto" px={4}>
        <VStack align="stretch" spacing={6}>
          {/* 背景調整セクション */}
          <Box>
            <Text fontSize="sm" fontWeight="bold" mb={2}>
              室内の明るさに合わせてページ背景の明るさを調整してください
            </Text>
            <Slider
              defaultValue={0}
              min={0}
              max={4}
              step={1}
              onChange={(val) => setBgIndex(val)}
              mb={4}
            >
              <SliderTrack bg="gray.200">
                <SliderFilledTrack bg="gray.500" />
              </SliderTrack>
              <SliderThumb />
            </Slider>
            <BackButton />
          </Box>

          <Divider borderColor={dividerColors[bgIndex]} />

          {/* 症例情報 */}
          <Box>
            <Heading size="lg" mb={2}>
              {chosencase?.casetitle}
            </Heading>
            <Text
              fontSize="md"
              color="gray.600"
              whiteSpace="pre-line"
              mb={4}
              dangerouslySetInnerHTML={{
                __html:
                  chosencase?.members
                    ?.split(/([、,\s]+)/)
                    .map((part) =>
                      part.replace(
                        /([^\s\d、]+?)([0-9]）)/g,
                        (_, name, num) => {
                          return `${name}<sup>${num}</sup>`;
                        }
                      )
                    )
                    .join("") || "",
              }}
            />
            <Divider mb={4} borderColor={dividerColors[bgIndex]} />
            <Text whiteSpace="pre-line" fontSize="md">
              {chosencase?.detail}
            </Text>
          </Box>
          {/* DICOMボタン */}
          {chosencase?.dicomlink && Array.isArray(chosencase.dicomlink) && (
            <>
              <Divider borderColor={dividerColors[bgIndex]} />
              <Box>
                {chosencase.dicomlink.map((link, index) => (
                  <Box key={index} mb={2}>
                    <DicomLinkButton
                      link={link}
                      label={`Dicom画像${index + 1}`} // ← ボタンの表示名
                    />
                  </Box>
                ))}
              </Box>
            </>
          )}

          <Divider borderColor={dividerColors[bgIndex]} />

          {/* 戻るボタン（2個目） */}
          <Box>
            <BackButton />
          </Box>
        </VStack>
      </Box>
    </Box>
  );
}
